export function trayProfileInitials(
  name?: string | null,
  email?: string | null,
) {
  return (
    name
      ?.trim()
      .split(/\s+/)
      .slice(0, 2)
      .map((part) => part[0])
      .join("")
      .toLocaleUpperCase() ||
    email?.[0]?.toLocaleUpperCase() ||
    "D"
  );
}
